var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input-checkbox',{attrs:{"label":"Debug Mode","label-class":"text-gray-100"},on:{"change":_vm.toggleDebugMode}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }